/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportSubTypeBo } from '../../models/report-sub-type-bo';

export interface GetSubTypeNst$Params {
}

export function getSubTypeNst(http: HttpClient, rootUrl: string, params?: GetSubTypeNst$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportSubTypeBo>>> {
  const rb = new RequestBuilder(rootUrl, getSubTypeNst.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportSubTypeBo>>;
    })
  );
}

getSubTypeNst.PATH = '/svg/nst/subType';
